export default __webpack_public_path__ + "static/media/notepad.28fe84c6.svg";